import { render, staticRenderFns } from "./elementProperties.vue?vue&type=template&id=b82e6d22"
import script from "./elementProperties.ts?vue&type=script&lang=js&external"
export * from "./elementProperties.ts?vue&type=script&lang=js&external"
import style0 from "./elementProperties.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports